import { Button, HStack, Spacer } from '@sgme/ui';

/**
 * Props du composant MarginControlButtons
 */
type MarginControlButtonsProps = {
  /**
   * Callback pour décrémenter bid et ask
   */
  onDecrement: () => void;

  /**
   * Callback pour incrémenter bid et ask
   */
  onIncrement: () => void;

  /**
   * Callback pour décaler vers la gauche (bid +, ask -)
   */
  onShiftLeft: () => void;

  /**
   * Callback pour décaler vers la droite (bid -, ask +)
   */
  onShiftRight: () => void;

  /**
   * Callback pour réinitialiser la valeur
   */
  onReset?: () => void;

  /**
   * Indicate if the controls are editable
   */
  isEditable: boolean;

  /**
   * Préfixe pour les attributs data-e2e
   */
  dataE2ePrefix: string;
};

/**
 * Groupe de boutons de contrôle pour ajuster les valeurs de marge
 * Inclut : décrement, increment, shift left, shift right, et reset
 */
export function MarginControlButtons(props: MarginControlButtonsProps) {
  const { onDecrement, onIncrement, onShiftLeft, onShiftRight, onReset, isEditable, dataE2ePrefix } = props;

  return (
    <HStack verticalAlignment="center">
      <div className="btn-group">
        <Button
          size="sm"
          iconPosition="icon-only"
          onClick={onDecrement}
          disabled={!isEditable}
          data-e2e={`${dataE2ePrefix}-decrement-button`}
        >
          <i className="icon fw-bold">remove</i>
        </Button>

        <Button
          size="sm"
          iconPosition="icon-only"
          onClick={onIncrement}
          disabled={!isEditable}
          data-e2e={`${dataE2ePrefix}-increment-button`}
        >
          <i className="icon fw-bold">add</i>
        </Button>

        <Button
          size="sm"
          iconPosition="icon-only"
          onClick={onShiftLeft}
          disabled={!isEditable}
          data-e2e={`${dataE2ePrefix}-shift-left-button`}
        >
          <i className="icon fw-bold">chevron_left</i>
        </Button>

        <Button
          size="sm"
          iconPosition="icon-only"
          onClick={onShiftRight}
          disabled={!isEditable}
          data-e2e={`${dataE2ePrefix}-shift-right-button`}
        >
          <i className="icon fw-bold">chevron_right</i>
        </Button>
      </div>

      <Spacer />

      {onReset && (
        <Button
          size="sm"
          iconPosition="icon-only"
          onClick={onReset}
          disabled={!isEditable}
          data-e2e={`${dataE2ePrefix}-reset-button`}
        >
          <i className="icon fw-bold">replay</i>
        </Button>
      )}
    </HStack>
  );
}
